import UserModelBuilder from "src/models/builders/UserModelBuilder";
import { IConfigStorage } from "src/models/interfaces/IConfigStorage";
import SettingsModel from "src/models/settingsModel";
import IStorage from "src/utils/IStorage";
import SessionStorage from "src/utils/SessionStorage";
import FunctionService from "./Function.service";
import ErrorService from "./Error.service";

type LoginUserType = {
  userModel: UserModelBuilder;
  lang: string
}

type LoginServiceType = {
  loginUser: (profileData: any) => Promise<LoginUserType>,
  getLogin: (profileData: any) => Promise<SettingsModel>
}

/**
 * @class LoginService
 */
export function LoginService(): LoginServiceType {
  const { getUserfunctions } = FunctionService();

  /**
   * @description Obtiene los datos del usuario logeado.
   * @returns {UserModelBuilder}
   */
  async function loginUser(profileData: any): Promise<LoginUserType> {
    let lang = "en";
    const usr: UserModelBuilder = new UserModelBuilder();
    usr.setId(profileData.id || profileData.graphData.id)
      .setFirstName(profileData.givenName || profileData.graphData.givenName)
      .setLastName(profileData.surname || profileData.graphData.surname)
      .setEmail(profileData.mail || profileData.userPrincipalName || profileData.graphData.userPrincipalName)
      .setPhoto(profileData.profilePhoto || profileData.graphData.profilePhoto || "");

    await fetch(
      '/api/login',
      {
        credentials: 'include',
        headers: {
          contentType: "application/json; charset=utf-8",
          Authorization: `${usr.get().email}`
        }
      })
      .then(response => {
        return response.status === 200 ? response.json() : null;
      })
      .then(
        data => {
          if (data !== null) {
            if (usr.getEmail() === data.email) usr.setId(data.id);
            data.lang && (lang = data.lang);
          }
        }
      ).catch(
        error => {
          throw ErrorService(error);
        }
      );
    return {
      userModel: usr,
      lang: lang
    };
  }

  /**
   * @description Loguea el usuario y valida si los datos son válidos.
   * @returns {Promise<AuthTypes>}
   */
  const getLogin = (profileData: any): Promise<SettingsModel> => {
    const storageData: IStorage = new SessionStorage();
    const data = storageData.getStorage('config');

    const config: SettingsModel = data !== null ? new SettingsModel(data as IConfigStorage) : new SettingsModel();

    return new Promise((resolve, reject) => {
      loginUser(profileData).then((data) => {
        const usr = data.userModel;
        // Setea el lenguaje del usuario al momento del login
        config.setLang(data.lang);
        if (usr) {
          let lstFunc: (string | number)[] = [];
          // Setea las funciones que tiene permisos el usuario.
          try {
            getUserfunctions(usr.getEmail(), usr.getId()).then(
              (functs) => {
                lstFunc = functs;
                config.setUser(usr.get()).setIdFunctions(lstFunc);
                resolve(config);
              }
            ).catch((err) => {
              reject(err);
            });
          } catch {
            reject("Function Error")
          }
        } else {
          reject("Login Error");
        }
      });
    });
  }

  return {
    loginUser,
    getLogin
  }
}
